import { useHistory, useRouteMatch } from 'react-router-dom';
import { DeclarativeModal, FunctionalLoader } from 'seagull';
import { routes } from "../../constants";
import { useStore, useStoreActions } from "../../contexts";
import { useDraft } from "../../hooks/reactQuery/queries/useDraft";
import { useOnMount } from "../../hooks/useOnMount";
import { selectors } from "../../store/state-selectors";
import { makeSentryIgnoredError } from "../ErrorBoundaryPage";
import { AgreementStudioProposalModeWithMobileSupport } from "./AgreementStudioProposalMode/AgreementStudioProposalMode";
import { useFetchAgreementStudioData } from "./hooks/useFetchAgreementStudioData";
import { jsx as _jsx } from "react/jsx-runtime";
export default function AgreementStudioPage(props) {
  const {
    returnRoute,
    autoSaveTimeout,
    viewProposalMode,
    disableDataFetching,
    onClose
  } = props;
  const {
    params
  } = useRouteMatch();
  const draftId = params === null || params === void 0 ? void 0 : params.draftId;
  const {
    draft,
    isFetching
  } = useDraft({
    draftId,
    refreshOnHookMount: true
  });
  const history = useHistory();
  const {
    fetchLegalTerms
  } = useStoreActions();
  const worksAt = useStore(selectors.user.business);
  const userEmail = useStore(selectors.user.email);
  const fetchAgreementStudioData = useFetchAgreementStudioData();
  useOnMount(() => {
    if (!disableDataFetching) fetchAgreementStudioData();
  });
  if (!worksAt || !userEmail) throw makeSentryIgnoredError('noBusiness');
  if (isFetching) return /*#__PURE__*/_jsx(FunctionalLoader, {
    show: true
  });
  return /*#__PURE__*/_jsx(DeclarativeModal, {
    isOpen: true,
    onClose: onClose,
    content: _ref => {
      let {
        dismissModal
      } = _ref;
      return /*#__PURE__*/_jsx(AgreementStudioProposalModeWithMobileSupport, {
        isTemplateProposal: false,
        autoSaveTimeout: autoSaveTimeout,
        viewProposalMode: viewProposalMode,
        draft: draft || null,
        worksAt: worksAt,
        userEmail: userEmail,
        onUploadLegalTermsDocument: fetchLegalTerms,
        onClose: () => {
          if (returnRoute) {
            if (history.location.pathname !== returnRoute) {
              history.push(returnRoute);
            }
          } else if (draftId) {
            history.push(routes.draftsDashboard);
          } else {
            const canGoBack = history.length > 1;
            const locationState = history.location.state;
            const isFromPostAgreementFlow = locationState === null || locationState === void 0 ? void 0 : locationState.fromPostAgreement;
            if (canGoBack && !isFromPostAgreementFlow) {
              history.goBack();
            } else {
              history.push(routes.proposalsDashboard);
            }
          }
          dismissModal();
        }
      });
    }
  });
}